import http from '../http-common'

class SimService {
  async check(data) {
    const {
      msisdn,
      iccid,
      imsi = '',
      status = 'PREALLOC',
      subType = '',
      idType = '',
      isRedeem = false,
      isGlobalDomain = false,
    } = data
    let params = {
      msisdn,
      iccid,
      imsi,
      status,
      isRedeem,
      isGlobalDomain,
    }

    if (subType) {
      params = { ...params, subType: subType }
    }

    if (idType) {
      params = { ...params, idType: idType }
    }

    const queryString = new URLSearchParams(params).toString()

    const response = await http.get(`/sims/check?${queryString}`)

    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }

  async register(data) {
    const response = await http.post('/sims/register', data)
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }

  async portin(data) {
    const response = await http.post('/sims/portin', data)
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }

  async order(orderId) {
    const response = await http.get(`/sims/order?orderId=${orderId}`)
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }

  async esim(msisdn, iccid) {
    const response = await http.get(
      `/sims/esim?msisdn=${msisdn}&iccid=${iccid}`
    )
    if (response.data.error) {
      throw new Error(response.data.error.message)
    }
    return response.data
  }
}

export default new SimService()
